import SlideRoutes from "@thenumber/react-slide-routes";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Scrollbars from "react-custom-scrollbars";
import { Route, useLocation } from "react-router-dom";
import { usePrefetchCatalogFloorplan } from "../adapters/uplist";
import { OrderNavBar } from "../components";
import Footer from "../components/order/Footer";
import OrderForm from "../components/order/OrderForm";
import { FORM_NAV_LIST, FORM_PATH_LIST } from "../helpers/constants";
import {
  AerialPage,
  BundlePage,
  FloorPlansPage,
  MatterportPage,
  NewOrderPage,
  PhotosPage,
  PrintPage,
  SignPage,
  StockPhotoPage,
  SubmitPage,
  VideoPage,
} from "../pages";
import OrderRedirectRoute from "./hoc/OrderRedirectRoute";

const Routes = () => {
  const location = useLocation();
  return (
    <>
      <SlideRoutes
        location={location}
        pathList={FORM_PATH_LIST}
        duration={500}
        animation="vertical-slide"
        // destroy={false}
      >
        <Route path="/new-order" component={NewOrderPage} />
        <OrderRedirectRoute path="/bundles" component={BundlePage} />
        <OrderRedirectRoute path="/stock-photos" component={StockPhotoPage} />
        <OrderRedirectRoute path="/photos" component={PhotosPage} />
        <OrderRedirectRoute path="/floorplans" component={FloorPlansPage} />
        <OrderRedirectRoute path="/matterport" component={MatterportPage} />
        <OrderRedirectRoute path="/video" component={VideoPage} />
        <OrderRedirectRoute path="/aerial" component={AerialPage} />
        <OrderRedirectRoute path="/sign" component={SignPage} />
        <OrderRedirectRoute path="/print" component={PrintPage} />
        <OrderRedirectRoute path="/submit" component={SubmitPage} />
      </SlideRoutes>
      <Footer list={FORM_NAV_LIST} />
    </>
  );
};

const FormRoutes = () => {
  usePrefetchCatalogFloorplan();
  return (
    <Container fluid="sm">
      <Row className="mx-0">
        <Col md={2} className="d-lg-flex flex-column py-4 px-0 d-none vh-100">
          <Scrollbars autoHide>
            <OrderNavBar />
          </Scrollbars>
        </Col>
        <Col className="px-0">
          <OrderForm>
            <Routes />
          </OrderForm>
        </Col>
      </Row>
    </Container>
  );
};

export default FormRoutes;
